module.exports = __webpack_public_path__ + "img/淡印白膜.1cb1ba90.jpg";